<template>
  <div class="content-wrapper">
    <div class="content-header">
      <div class="title">付费管理-{{$route.query.vendorName}}</div>
    </div>
    <ordered-table ref="ordered"
      :fetch="fetch" />
    <no-order-table ref="order"
      :fetch="fetch" />
    <div class="content-submit">
      <back-button />
    </div>
  </div>
</template>
<script>
import NoOrderTable from './busi/no-order-table.vue'
import OrderedTable from './busi/ordered-table.vue'
export default {
  name: 'vacorder-detail',
  components: { NoOrderTable, OrderedTable },
  props: {},
  data () {
    return {}
  },
  watch: {},
  computed: {},
  methods: {
    back () {
      this.$router.go(-1)
    },
    fetch () {
      this.$refs.ordered.fetchList()
      this.$refs.order.fetchList()
    }
  },
  created () { },
  mounted () { }
}
</script>
<style lang="stylus" scoped></style>
